import { render, staticRenderFns } from "./GroupPaywallIllustration.vue?vue&type=template&id=51acb670&scoped=true&"
import script from "./GroupPaywallIllustration.vue?vue&type=script&lang=ts&"
export * from "./GroupPaywallIllustration.vue?vue&type=script&lang=ts&"
import style0 from "./GroupPaywallIllustration.vue?vue&type=style&index=0&id=51acb670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51acb670",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('51acb670', component.options)
    } else {
      api.reload('51acb670', component.options)
    }
    module.hot.accept("./GroupPaywallIllustration.vue?vue&type=template&id=51acb670&scoped=true&", function () {
      api.rerender('51acb670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/group-plans/svgs/GroupPaywallIllustration.vue"
export default component.exports